<template>
    <div>
        <b-card>
          <h3>Cold Water</h3>
          <br/>
          <b-row>
            <b-col>show all the cold water questions here</b-col>
          </b-row>
        </b-card>
    </div>
</template>

<script>
    export default {
      data() {
      return {
        stepComplete: false,
      }
    },
    computed: {},
    components: {},
    methods:{},

    }
</script>

<style>

</style>